import React from 'react';

const PrivacyPolicyComponent = ({ title, lastUpdated, contentData }) => {
  const renderContent = (item, index) => {
    if (typeof item === 'string') {
      return (
        <p key={index} className="text-dark lh-lg">
          {item}
        </p>
      );
    }

    if (item?.type === 'list') {
        return (
            <ul
            key={index}
            className="ps-4 mb-3"
            style={{ listStyleType: 'disc' }}
            >
            {item?.items?.map((listItem, i) => (
                <li key={i} className="mb-2">
                {listItem}
                </li>
            ))}
            </ul>
        );
    }

    if (item?.type === 'subsection') {
        return (
            <div key={index} className="mt-4">
            <h6 className="fw-semibold text-dark mb-2">
                {item?.title}
            </h6>
            <ul
                className="ps-4"
                style={{ listStyleType: 'disc' }}
            >
                {item?.items?.map((subItem, i) => (
                <li key={i} className="mb-2">
                    {subItem}
                </li>
                ))}
            </ul>
            </div>
        );
    }

    return null;
  };

  return (
    <div className="card shadow-sm border-0">
      <div className="card-body p-4 p-md-5">

        {/* Header */}
        <div className="mb-4">
          <h2 className="fw-bold mb-1 text-center mb-3">{title}</h2>
          <p className="text-muted mb-0">
            Intelligra Solutions Limited
          </p>
          <small className="text-muted">
            Last Updated: {lastUpdated}
          </small>
        </div>

        <hr className="mb-4" />

        {/* Sections */}
        {contentData?.map((section) => (
          <section key={section?.id} className="mb-5">

            <div className="d-flex align-items-start mb-3">
              <span className="badge bg-primary me-3 mt-1">
                {section?.id}
              </span>
              <h5 className="fw-bold mb-0">
                {section?.title}
              </h5>
            </div>

            <div className="ps-1">
              {section?.content?.map((item, index) =>
                renderContent(item, index)
              )}
            </div>

          </section>
        ))}

      </div>
    </div>
  );
};

export default PrivacyPolicyComponent;
